import { render, staticRenderFns } from "./homeTask.vue?vue&type=template&id=faa5fa6e&"
import script from "./homeTask.vue?vue&type=script&lang=js&"
export * from "./homeTask.vue?vue&type=script&lang=js&"
import style0 from "./homeTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports